import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/organization_admins`;

type OrganizationAdminsRecordType = Required<{
  email: string;
  family_name: string | null;
  given_name: string | null;
}>;

const organizationAdminsRecords: OrganizationAdminsRecordType[] = [
  {
    email: 'organization.admin.owner.1@dummy.com',
    family_name: '組織',
    given_name: 'オーナー１',
  },
  {
    email: 'organization.admin.admin.2@dummy.com',
    family_name: '組織',
    given_name: '管理者２',
  },
  {
    email: 'organization.admin.admin.3@dummy.com',
    family_name: null,
    given_name: '管理者３',
  },
  {
    email: 'organization.admin.admin.4@dummy.com',
    family_name: '管理者４',
    given_name: null,
  },
];

export const organizationAdminsHandlers = [
  // 自身の組織の組織管理者一覧
  http.get(baseUrl, (_) => {
    const response = {
      admins: organizationAdminsRecords,
    };

    console.info(response);
    return HttpResponse.json(response);
  }),
];
